module.exports = __webpack_public_path__ + "5b0ba87abdf39ac305b1eaca1dc54e76.png";